import SwalCustom from '../../alert/swal-custom'

function Error_500(error) {
  return SwalCustom({
    title: 'พบข้อผิดพลาด',
    text: `กรุณาบันทึกภาพหน้าจอ แล้วแจ้ง IT เพื่อแก้ไขปัญหา ${
      error && `(Ref. ${error?.response?.status ?? error})`
    }`,
    icon: 'error',
    showCancelButton: false,
    confirmButtonColor: 'red',
    confirmButtonText: 'Close'
  })
}

export default Error_500
